import { Col, Container } from "reactstrap";
import { Btn, H3, P, Image } from "../../../../AbstractElements";
import { BackToHomePage } from "../../../../utils/Constant";
import { CommonErrorPageType } from "../../../../types/other-pages/OtherPages";
import { dynamicImage } from "../../../../service";

const CommonError: React.FC<CommonErrorPageType> = ({ src }) => {
  return (
    <div className="page-wrapper compact-wrapper">
      <div className="error-wrapper" style={{ position: "relative" }}>
        <Container>
          <div style={{ position: "absolute", top: 10, left: 0, zIndex: 10 }}>
            <Image
              src={dynamicImage("dashboard-8/Linnk_Group_logo.png")}
              alt="comingsoon"
              style={{ width: "90px", height: "auto" }}
            />
          </div>
          <div className="svg-wrraper">
            {src}
          </div>
          <Col md="8" className="offset-md-2">
            <H3>Page Not Found</H3>
            <P className="sub-content">
              {
                "The page you are attempting to reach is currently not available. This may be because the page does not exist or has been moved."
              }
            </P>
            <Btn
              tag="a"
              color={`primary`}
              href={`${process.env.PUBLIC_URL}/dashboard`}
            >
              {BackToHomePage}
            </Btn>
          </Col>
        </Container>
      </div>
    </div>
  );
};

export default CommonError;